<script setup>
import { onMounted, ref } from 'vue'
import emblaCarouselVue from 'embla-carousel-vue'
import AutoScroll from 'embla-carousel-auto-scroll'
import SaleCard from '@/Components/Inputs/BlockEditor/Extension/Components/Sales/SaleCard.vue'

const props = defineProps({
  sales: {
    type: Object,
    required: true
  },
})

const selectedSlide = ref(0)

const [emblaRefMain, emblaApiMain] = emblaCarouselVue({ loop: true },
  [
    AutoScroll({
      playOnInit: true,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      speed: 1,
      startDelay: 0,
    })
  ])

const [emblaRefThumb] = emblaCarouselVue({ active: false })

onMounted(() => {
  emblaApiMain.value.on('select', (slide) => selectedSlide.value = slide.selectedScrollSnap())
})
</script>

<template>
  <div class="embla overflow-hidden  h-36 xs:h-44 sm:h-52"
       ref="emblaRefMain"
  >
    <div class="embla__container flex h-full">
      <div v-for="(sale, index) in sales "
           class="embla__slide translate-z-0 pl-2 flex-shrink-0 h-full aspect-1"
           :key="sale.id"
           @mouseenter="selectedSlide = index"
      >
        <SaleCard :sale="sale" />
      </div>
    </div>
  </div>
  <div class="embla-thumbs__viewport space-x-2 flex items-center h-4 justify-center"
       ref="emblaRefThumb"
  >
    <div v-for="(sale, index) in sales" class="space-x-2 flex items-center h-4 justify-center">
      <div
        class="size-2 bg-gray-300 rounded-full transition-all ease-in-out duration-300"
        :key="sale.id"
        :class="{'!size-4': selectedSlide === index}"
      />
    </div>
  </div>

</template>
